import { configureStore } from "@reduxjs/toolkit";

import accountSetupReducer from "../redux/features/auth/accountSetupSlice";
import authReducer from "../redux/features/auth/authSlice";
import schoolYearReducer from "../redux/features/schoolYears/schoolYearSlice";
import fieldConfigReducer from "../redux/features/fieldConfigs/fieldConfigSlice";
import userReducer from "../redux/features/users/userSlice";
import clientReducer from "../redux/features/clients/clientSlice";
import dossierReducer from "../redux/features/dossiers/dossierSlice";
import dashboardReducer from "../redux/features/dashboard/dashboardSlice";
import settingsReducer from "../redux/features/settings/settingsSlice";
export const store = configureStore({
  reducer: {
    accountSetup: accountSetupReducer,
    auth: authReducer,
    schoolYears: schoolYearReducer,
    fieldConfigs: fieldConfigReducer,
    users: userReducer,
    clients: clientReducer,
    dossiers: dossierReducer,
    dashboard: dashboardReducer,
    settings: settingsReducer,
  },
});
